module.exports = __webpack_public_path__ + "static/media/PBM_Protocol.92d05df2.png";